import { NavLink } from "react-router-dom";

function NavMenu() {
  return (
    <div className="navMenu">
      <div className="navbarContainer">
        <div className="botonera">
          <NavLink
            to={"/proyectos"}
            className="btn wow animate__animated animate__flip animate__delay-0s"
          >
            <i
              className="bi bi-house-heart"
              data-toggle="tooltip"
              data-placement="right"
              title="proyectos"
            >
              {" "}
            </i>
          </NavLink>
          <NavLink
            to={"/residencias"}
            className="btn wow animate__animated animate__flip animate__delay-1s"
          >
            <i className="bi bi-globe-americas"
            data-toggle="tooltip"
            data-placement="right"
            title="residencias"> </i>
                   </NavLink>
          <NavLink
            to={"/muestras"}
            className="btn wow animate__animated animate__flip animate__delay-2s"
          >
            <i className="bi bi-images" data-toggle="tooltip"
              data-placement="right"
              title="muestras"> </i>
            
          </NavLink>
          <NavLink
            to={"/nosotras"}
            className="btn wow animate__animated animate__flip animate__delay-4s"
          >
            <i className="bi bi-person-heart" data-toggle="tooltip"
              data-placement="right"
              title="nosotras"> </i>
            
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default NavMenu;
